import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App/App";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Auth/authConfig";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { runtimeConfig } from "./runtimeConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

const startApp = async () => {
    try {
        msalInstance.initialize().then(() => {
            msalInstance.handleRedirectPromise().then((response) => {
                if (response?.account) {
                    msalInstance.setActiveAccount(response.account);
                } else {
                    const accounts = msalInstance.getAllAccounts();
                    if (accounts.length > 0) {
                        msalInstance.setActiveAccount(accounts[0]);
                    }
                }

                if (runtimeConfig.ENVIRONMENT === "Production") {
                    window.console.error = () => {
                    };
                }

                const root = createRoot(document.getElementById("root"));
                root.render(
                    <BrowserRouter>
                        <App msalInstance={msalInstance}/>
                    </BrowserRouter>
                );
            });
        });
    } catch (error) {
        console.error("Error initializing MSAL:", error);
    }
};

startApp();

